module.exports = __webpack_public_path__ + "images/emoji/trophy.70f089120c9456263acc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trophy.png
// module id = k9BL
// module chunks = 2